module.exports = __webpack_public_path__ + "static/media/close-banner-icon.fa547f38.svg";